module.exports = __webpack_public_path__ + "static/img/hzhb2.9e96528.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/hzhb2.png
// module id = F4cE
// module chunks = 0